import AdminCRUD from "@/components/admin/AdminCRUD";

const empty = { title: "", date: "", time: "", location: "", description: "", image_path: "", registration_url: "", kind: "upcoming", order: 0 };
const fields = [
  { name: "title", label: "Title", type: "text", required: true, placeholder: "e.g. Walk for Lives" },
  { name: "kind", label: "Type", type: "select", options: [{ value: "upcoming", label: "Upcoming" }, { value: "past", label: "Past" }], required: true },
  { name: "date", label: "Date", type: "text", placeholder: "e.g. Saturday, October 5, 2026" },
  { name: "time", label: "Time", type: "text", placeholder: "e.g. 10:00 AM" },
  { name: "location", label: "Location", type: "text", placeholder: "e.g. Lake Eola, Orlando FL" },
  { name: "description", label: "Description", type: "textarea", rows: 5, placeholder: "Details about the event..." },
  { name: "image_path", label: "Event image / flyer", type: "image", help: "Upload a JPG/PNG/WebP (max 10MB) - or paste an existing URL below." },
  { name: "registration_url", label: "Registration / info link", type: "text", placeholder: "https://..." },
];

export default function AdminEvents() {
  return (
    <AdminCRUD
      title="Events"
      description="Add upcoming events (rallies, fundraisers, naloxone distributions) and past events for the public Events page."
      endpoint="events"
      emptyItem={empty}
      fields={fields}
      itemLabel={(e) => e.title || "(untitled)"}
      itemSubtitle={(e) => `${e.kind === "past" ? "Past" : "Upcoming"} · ${e.date || "no date"}${e.location ? " · " + e.location : ""}`}
    />
  );
}
